import { render, staticRenderFns } from "./fileCollect.vue?vue&type=template&id=553ae506&scoped=true"
import script from "./fileCollect.vue?vue&type=script&lang=js"
export * from "./fileCollect.vue?vue&type=script&lang=js"
import style0 from "./fileCollect.vue?vue&type=style&index=0&id=553ae506&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ae506",
  null
  
)

export default component.exports